import * as React from 'react'
import { SVGProps } from 'react'
const SvgCrossLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 263 225"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#fff" d="M0-1h262v226H0z" />
    <path
      opacity={0.3}
      d="M83.096 162.696c43.177 28.692 102.41 49.465 137.534 1.093 31.884-43.881 5.852-104.415-51.114-111.431-24.573-3.033-43.982 13.042-68.665 6.078-24.682-6.965-50.155-28.714-73.08-3.278-35.5 39.389 26.91 88.668 55.325 107.538Z"
      fill="#FFF0F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M155.997 87.613a6.363 6.363 0 0 1 0 8.997l-19.527 19.174a7.953 7.953 0 0 1-11.246 0L106.05 96.61a6.363 6.363 0 0 1 8.997-8.997l15.8 15.8L147 87.613a6.362 6.362 0 0 1 8.997 0Z"
      fill="#E22726"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M155.997 136.39a6.363 6.363 0 0 0 0-8.997l-19.527-19.174a7.953 7.953 0 0 0-11.246 0l-19.174 19.174a6.363 6.363 0 0 0 8.997 8.997l15.8-15.8L147 136.39a6.36 6.36 0 0 0 8.997 0Z"
      fill="#E22726"
    />
    <path
      d="M181.105 112.5c3.808 0 6.938 3.098 6.475 6.878a56.497 56.497 0 0 1-75.394 46.218 56.498 56.498 0 0 1-23.98-89.398 56.502 56.502 0 0 1 59.164-17.923c3.655 1.07 5.262 5.17 3.755 8.667-1.506 3.498-5.558 5.052-9.252 4.127a42.71 42.71 0 1 0 31.782 48.296c.612-3.758 3.642-6.865 7.45-6.865Z"
      fill="#E22726"
    />
  </svg>
)
export default SvgCrossLogo
